import BackButton from 'components/backButton'
import UpdateInventoryForm from 'components/inventory/updateInventoryForm'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'

const UpdateInventory = () => {
  const navigate = useNavigate()

  const handleBack = () => {
    navigate(-1)
  }

  return (
    <>
      <Helmet>
        <title>ORMS Update Master Data</title>
      </Helmet>

      <BackButton handleBack={handleBack} />

      <UpdateInventoryForm />
    </>
  )
}

export default UpdateInventory
